import FetchExtension from '@/core/extensions/FetchExtension';
// service 
import ServiceBase from "@/core/services/ServiceBase";
// interface
import TFetchExtension from '@/core/types/TFetchExtension';
import { IOdataGetRequest } from '@/core/types/TGetRequest';
// enum
import HttpMethodEnum from '@/core/enums/EHttpMethod';
import EndpointProtocol from '@/core/enums/EEndpointProtocol';


class OdataCoreServiceBase extends ServiceBase {

	async get( params: IOdataGetRequest ): Promise<any> {

		const apiFetchConfig: TFetchExtension = {
			// protocol: EndpointProtocol.ODATA,
            method: HttpMethodEnum.GET,
			language: params.language,
            
			sourcePath: this.sourcePath,
			queryOptions: params.queryOptions
		}

		return FetchExtension(apiFetchConfig);
	
    }

	async search( params: IOdataGetRequest ): Promise<any> {

		const apiFetchConfig: TFetchExtension = {
            // protocol: EndpointProtocol.ODATA,
			method: HttpMethodEnum.GET,
            language: params.language,

			sourcePath: `${this.sourcePath}/search`,
            queryOptions: params.queryOptions
		}

		return FetchExtension(apiFetchConfig);
	
    }

}

export default OdataCoreServiceBase;
